import VendedorFab from './VendedorFab';

export default VendedorFab;
